import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { toPng } from 'html-to-image';

interface QRCodeComponentProps {
  value: string;
}

const QRCodeComponent: React.FC<QRCodeComponentProps> = ({ value }) => {
  const qrCodeRef = useRef<HTMLDivElement>(null);

  const downloadQRCode = () => {
    if (qrCodeRef.current === null) {
      return;
    }

    toPng(qrCodeRef.current)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'qrcode.png';
        link.click();
      })
      .catch((error) => {
        console.error('Erro ao gerar o QR code como imagem:', error);
      });
  };

  return (
    <div style={{ padding: '10px', background: 'none', justifySelf: 'center' }}>
      <div ref={qrCodeRef} >
        <QRCodeSVG value={value} size={200} />
      </div>
      <button onClick={downloadQRCode}>Exportar QR Code</button>
    </div>
  );
};

export default QRCodeComponent;
